import { render, staticRenderFns } from "./ComixNavbar.vue?vue&type=template&id=1d28efe1&scoped=true&"
import script from "./ComixNavbar.vue?vue&type=script&lang=js&"
export * from "./ComixNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ComixNavbar.vue?vue&type=style&index=0&id=1d28efe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28efe1",
  null
  
)

export default component.exports